import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { Parallax } from "react-skrollr";
import { multiLanguage } from "../../hoc";
import { Logo, Slider } from "../../components";
import { assetsPath } from "../../utils";

@multiLanguage()
export default class Concept extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
  };
  render() {
    const { page, t, imageSlider, content } = this.props;
    let logoImage = `${assetsPath(page)}/images/logo/logo-gray.png`;
    if (page === "phuket-dusit-deluxe-pool-villa") {
      logoImage = `${assetsPath(page)}/images/logo/logo-white.png`;
    } else if (page === "phuket-skypark") {
      logoImage = `${assetsPath(page)}/images/logo/logo-white.png`;
    } else if (page === "laguna-beachside") {
      logoImage = `${assetsPath(page)}/images/logo/logo-white.png`;
    } else if (page === "laguna-seaside-residences") {
      logoImage = `${assetsPath(page)}/images/logo/logo-white.png`;
    } else if (page === "laguna-seaside-residences-dev") {
      logoImage = `${assetsPath(page)}/images/logo/logo-white.png`;
    }

    console.log("logoImage", { page, logoImage });

    return (
      <div className="section-concept">
        <div className="row no-gutters">
          <div className="col-xl-6">
            <div className="parallax-container">
              <Parallax
                data={{
                  "data-top-top": "transform: translateY(0px);",
                  // "data-top-bottom": "transform: translateY(250px);"
                }}
              >
                <div className="image-slider-block">
                  <Slider
                    settings={{
                      arrows: false,
                      dots: true,
                    }}
                    items={imageSlider}
                    uiRenderer={(item) => {
                      return (
                        <div
                          className="img-background"
                          style={{
                            backgroundImage: `url('${_.get(item, "image")}')`,
                            backgroundPosition: _.get(
                              item,
                              "backgroundPosition",
                              "center center"
                            ),
                          }}
                        />
                      );
                    }}
                  />
                </div>
              </Parallax>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="content-block">
              <Logo src={logoImage} />
              <h2
                style={{
                  // marginTop: page === "laguna-beachside" ? "80px" : "30px",
                  marginTop: "80px",
                  marginBottom: "20px",
                }}
              >
                {t("Concept")}
              </h2>
              <div
                className="description"
                dangerouslySetInnerHTML={{
                  __html: t(content),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/Concept.js